import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment/moment'
import {
	selectEngagementChart,
} from './reports.selectors'
import isEmpty from 'lodash/isEmpty'
import DashboardCard from '../../components/cards/DashboardCard'
import { ChartContainer, ChartTooltip } from '../../components/ui/chart'
import { CartesianGrid, LineChart, XAxis, YAxis, Line } from 'recharts'
import { cn } from '../../lib/utils'

const SIX_MONTHS = 180

const EngagementChart = () => {
	const engagementChart = useSelector(selectEngagementChart) as any

	const chartConfig = {
		newVersionsCreated: {
			label: 'New Versions Created',
			color: 'rgba(178,223,138,1)',
		},
		documentsUploaded: {
			label: 'Documents Uploaded',
			color: 'rgba(251,154,153,1)',
		},
		flaggedGreen: {
			label: 'Flagged Green',
			color: 'rgba(51,160,44,1)',
		},
		flaggedYellow: {
			label: 'Flagged Yellow',
			color: 'rgba(253,191,111,1)',
		},
		flaggedRed: {
			label: 'Flagged Red',
			color: 'rgba(255,0,0,1)',
		},
		FFLUserLogins: {
			label: 'FFL User Logins',
			color: 'rgba(202,178,214,1)',
		},
		ATFUserLogins: {
			label: 'ATF User Logins',
			color: 'rgba(255,127,0,1)',
		},
		viewedByAtf: {
			label: 'Viewed by ATF',
			color: 'rgba(169,207,228,1)',
		},
	}

	return (
		<DashboardCard title='Engagement'>

			{!isEmpty(engagementChart) && (

				<ChartContainer config={chartConfig}>
					<LineChart
						data={engagementChart.map((each: any) => ({
							date: moment(each.engagementDate).format('MMM DD, YYYY'),
							newVersionsCreated: each.newVersionsCreated,
							documentsUploaded: each.documentsUploaded,
							flaggedGreen: each.flaggedGreen,
							flaggedYellow: each.flaggedYellow,
							flaggedRed: each.flaggedRed,
							FFLUserLogins: each.FFLUserLogins,
							ATFUserLogins: each.ATFUserLogins,
							viewedByAtf: each.viewedByAtf,
						}))}
						margin={{
							left: 20,
							right: 20,
							top: 20,
							bottom: 20,
						}}
					>
						<CartesianGrid vertical={false} />
						<XAxis dataKey="date"
							tickLine={false}
							axisLine={false}
							tickMargin={10}
						/>
						<YAxis />
						<ChartTooltip cursor={false} />
						{Object.keys(chartConfig).map((key) => (
							<Line type="monotone" label={chartConfig[key].label} dataKey={key} strokeWidth={2} stroke={chartConfig[key].color} dot={false} />
						))}

					</LineChart>

				</ChartContainer>

			)}
			<div className='flex flex-wrap gap-2'>
				{Object.keys(chartConfig).map((key) => (
					<div key={key} className='flex items-center justify-start gap-1'>
						<span style={{ backgroundColor: chartConfig[key].color }} className={cn('w-3 h-3 rounded-full')} />
						<span className='text-xs'>{chartConfig[key].label}</span>
					</div>
				))}
			</div>
		</DashboardCard>
	)
}

export default EngagementChart
